import { render, staticRenderFns } from "./operateAuthMaintain.vue?vue&type=template&id=36f5af0f&scoped=true&lang=pug"
import script from "./operateAuthMaintain.vue?vue&type=script&lang=js"
export * from "./operateAuthMaintain.vue?vue&type=script&lang=js"
import style0 from "./operateAuthMaintain.vue?vue&type=style&index=0&id=36f5af0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5af0f",
  null
  
)

export default component.exports